import { Prop, Component, Vue } from 'vue-property-decorator';
import { normalizeComponent } from 'vue-runtime-helpers';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: 'marker2' })
    ], default_1.prototype, "iconName", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "width", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "height", void 0);
    __decorate([
        Prop({ default: 'currentColor' })
    ], default_1.prototype, "iconColor", void 0);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));

/* script */
const __vue_script__ = default_1;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 32 47",
        "aria-labelledby": _vm.iconName,
        role: "presentation"
      }
    },
    [
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M16 45C19.6286 45 23.0086 44.0847 25.5453 42.4993C28.0538 40.9315 30 38.5095 30 35.5C30 32.4905 28.0538 30.0685 25.5453 28.5007C23.0086 26.9153 19.6286 26 16 26C12.3714 26 8.99144 26.9153 6.45472 28.5007C3.94619 30.0685 2 32.4905 2 35.5C2 38.5095 3.94619 40.9315 6.45472 42.4993C8.99144 44.0847 12.3714 45 16 45Z",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "4"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M27.775 16.1442C28 14.9741 28 13.7607 28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 13.7752 4 14.9581 4.23062 16.0943C4.86097 19.1997 7.21428 21.9554 16 35.5C24.812 22.282 27.153 19.3784 27.775 16.1442ZM15.9999 17.0002C18.7613 17.0002 20.9999 14.7617 20.9999 12.0002C20.9999 9.23881 18.7613 7.00023 15.9999 7.00023C13.2385 7.00023 10.9999 9.23881 10.9999 12.0002C10.9999 14.7617 13.2385 17.0002 15.9999 17.0002Z",
            fill: _vm.iconColor
          }
        })
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
